<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Podcast Category</h2>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>
          Add Category
        </span>
      </base-button>
    </div>
    <CategoryTable />
  </b-card>
</template>

<script>
import CategoryTable from "./components/categoryTable.vue";
export default {
  components: {
    CategoryTable,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "add-podcast-category" });
    },
  },
};
</script>
<style></style>
